import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { FiX } from "react-icons/fi";
import { getLocalTemplatePreviewSrc } from "./templateCatalog";
import "./TemplatePreviewModal.css";

Modal.setAppElement("#root");

const getTemplatePreviewSrc = (template) =>
  getLocalTemplatePreviewSrc(template);

const TemplatePreviewModal = ({
  isOpen,
  onClose,
  template,
  onUseTemplate,
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [template?.templateId, template?.id]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!template) return null;

  const title = template.label || "Template";
  const description =
    template.description ||
    "Clean, single-column scroll with high contrast.";
  const badge = (template.type || template.badge || "SCROLL").toString();
  const previewSrc = getTemplatePreviewSrc(template);
  const showImage = Boolean(previewSrc) && !imageFailed;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="template-preview-modal"
      overlayClassName="template-preview-overlay"
      contentLabel="Template preview"
      shouldCloseOnOverlayClick
    >
      <div className="tpm-shell">
        <div className="tpm-preview">
          <div className="tpm-preview-stage">
            {showImage ? (
              <img
                className="tpm-preview-image"
                src={previewSrc}
                alt={`${title} preview`}
                onError={() => setImageFailed(true)}
              />
            ) : (
              <span className="tpm-preview-name">{title}</span>
            )}
          </div>
        </div>

        <aside className="tpm-details">
          <button
            type="button"
            className="tpm-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FiX size={14} strokeWidth={2.5} />
          </button>

          <div className="tpm-details-body">
            <span className="tpm-badge">{badge}</span>
            <h2 className="tpm-title">{title}</h2>
            <p className="tpm-description">{description}</p>
          </div>

          <button
            type="button"
            className="tpm-use-btn"
            onClick={onUseTemplate}
          >
            Use Template
          </button>
        </aside>
      </div>
    </Modal>
  );
};

export default TemplatePreviewModal;
